module.exports = __webpack_public_path__ + "img/full6-min.37dc5885.png";